import { render, staticRenderFns } from "./ResourceCreate.vue?vue&type=template&id=ce9f4132&"
import script from "./ResourceCreate.vue?vue&type=script&lang=js&"
export * from "./ResourceCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/staging.portal.letsreimagine.org/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ce9f4132')) {
      api.createRecord('ce9f4132', component.options)
    } else {
      api.reload('ce9f4132', component.options)
    }
    module.hot.accept("./ResourceCreate.vue?vue&type=template&id=ce9f4132&", function () {
      api.rerender('ce9f4132', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/resources/steps/ResourceCreate.vue"
export default component.exports